import { Component, Input } from '@angular/core';
import { PFFormatAccountDetail } from '../../../../data/interfaces/circle-credit.interface';

@Component({
  selector: 'app-circle-credit-account-detail-card',
  templateUrl: './circle-credit-account-detail-card.component.html',
  styleUrls: ['./circle-credit-account-detail-card.component.scss']
})
export class CircleCreditAccountDetailCardComponent {
  @Input() data: PFFormatAccountDetail | null = null;

  get hasData(): boolean {
    if (!this.data) return false;
    return !!(this.data.accountNumber || this.data.contractType || this.data.currentBalance);
  }

  get completionPercentage(): number {
    if (!this.data) return 0;
    
    const criticalFields = [
      'grantorKey', 'grantorName', 'accountNumber', 'contractType', 
      'accountType', 'accountStatus', 'openingDate', 'currentBalance',
      'creditLimit', 'lastPaymentDate', 'canStatus', 'canOpeningDate', 'canCancellationDate'
    ];
    const filledFields = criticalFields.filter(field => this.data![field as keyof PFFormatAccountDetail]);
    return Math.round((filledFields.length / criticalFields.length) * 100);
  }

  get statusClass(): string {
    if (!this.hasData) return 'status-empty';
    const percentage = this.completionPercentage;
    if (percentage < 30) return 'status-incomplete';
    if (percentage < 70) return 'status-partial';
    return 'status-complete';
  }

  get accountStatusDisplay(): string {
    if (!this.data?.accountStatus) return 'No especificado';
    
    const statusMap: { [key: string]: string } = {
      'A': 'Activa',
      'C': 'Cerrada',
      'V': 'Vencida',
      'P': 'Pagada',
      'S': 'Suspendida'
    };
    
    return statusMap[this.data.accountStatus] || this.data.accountStatus;
  }

  get contractTypeDisplay(): string {
    if (!this.data?.contractType) return 'No especificado';
    
    const typeMap: { [key: string]: string } = {
      'CC': 'Tarjeta de Crédito',
      'CR': 'Crédito Revolvente',
      'PH': 'Crédito Hipotecario',
      'AU': 'Crédito Automotriz',
      'PE': 'Crédito Personal',
      'CO': 'Crédito Comercial'
    };
    
    return typeMap[this.data.contractType] || this.data.contractType;
  }

  formatCurrency(amount: number | undefined): string {
    if (!amount && amount !== 0) return 'No especificado';
    return new Intl.NumberFormat('es-MX', {
      style: 'currency',
      currency: 'MXN'
    }).format(amount);
  }

  formatDate(date: string | undefined): string {
    if (!date) return 'No especificado';
    try {
      return new Date(date).toLocaleDateString('es-MX');
    } catch {
      return date;
    }
  }

  getCreditUtilization(): number {
    if (!this.data?.currentBalance || !this.data?.creditLimit) return 0;
    return Math.round((this.data.currentBalance / this.data.creditLimit) * 100);
  }

  getUtilizationClass(): string {
    const utilization = this.getCreditUtilization();
    if (utilization <= 30) return 'utilization-good';
    if (utilization <= 70) return 'utilization-warning';
    return 'utilization-danger';
  }
}
